var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","flat":"","color":"white","height":"92"}},[_c('v-toolbar-title',{staticClass:"text-no-wrap"},[_c('span',{staticClass:"font-weight-medium",attrs:{"role":"heading","aria-level":"1"}},[_vm._t("default")],2)]),_c('v-spacer'),_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }